import { render } from "./ContentBlocking.vue?vue&type=template&id=12c07d2a"
import script from "./ContentBlocking.vue?vue&type=script&lang=ts"
export * from "./ContentBlocking.vue?vue&type=script&lang=ts"
script.render = render

export default script